/**
 * Serviço de Plano de Contas
 * Comunicação com API de plano de contas
 */

import api from './api';

const planoContasService = {
  // Listar todas as contas
  listar: async (tipo = null) => {
    const params = tipo ? { tipo } : {};
    const response = await api.get('/plano-contas', { params });
    return response; // Interceptor já retorna response.data
  },

  // Buscar conta por ID
  buscarPorId: async (id) => {
    const response = await api.get(`/plano-contas/${id}`);
    return response;
  },

  // Criar nova conta
  criar: async (dados) => {
    const response = await api.post('/plano-contas', dados);
    return response;
  },

  // Atualizar conta
  atualizar: async (id, dados) => {
    const response = await api.put(`/plano-contas/${id}`, dados);
    return response;
  },

  // Deletar conta
  deletar: async (id) => {
    const response = await api.delete(`/plano-contas/${id}`);
    return response;
  },

  // Buscar contas (para autocomplete)
  buscar: async (termo = '', tipo = null, dedutivel = null) => {
    const params = { termo };
    if (tipo) params.tipo = tipo;
    if (dedutivel !== null) params.dedutivel = dedutivel;
    
    const response = await api.get('/plano-contas/buscar', { params });
    return response;
  }
};

export default planoContasService;
